var _g, _path, _path2, _path3;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgConexxus(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 184,
    height: 40,
    viewBox: "20 0 460 100",
    role: "img",
    "aria-label": "co-nexx.us",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fontFamily: "Geist, system-ui, -apple-system, 'Segoe UI', sans-serif",
    fontSize: 88,
    fontWeight: 500,
    letterSpacing: -3.52,
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("text", {
    x: 53,
    y: 78,
    textLength: 202,
    lengthAdjust: "spacing"
  }, "co-ne"), /*#__PURE__*/React.createElement("text", {
    x: 332,
    y: 78,
    textLength: 107,
    lengthAdjust: "spacing"
  }, ".us"))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(260, 10)",
    fill: "#FF6B1A"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 75,
    viewBox: "131 118 238 264",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M309.9,170.5c6,13.2,9.3,27.6,9.3,42.7c0,0.5,0.1,0.9,0.1,1.4l49.5-44v-52.5L309.9,170.5z",
    fill: "#FF6B1A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M303.5,213.3c0-52.4-46.9-95.1-104.5-95.1v39.2c35.2,0,63.9,23.9,65.2,53.7l-26.7,23.7c7.1,12.4,11.7,26.1,13.3,40.7l23.8-21.1c16.9,31.9,52.8,53.9,94.2,53.9v-39.2C332.8,269.1,303.5,244,303.5,213.3z",
    fill: "#FF6B1A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M301,381.5v-39.2c-36,0-65.3-25-65.3-55.8c0-52.4-46.9-95.1-104.5-95.1v39.2c30.6,0,56.3,18.1,63.3,42.4l-63.3,56.3v52.5l71.4-63.4C217,355.1,255.7,381.5,301,381.5z",
    fill: "#FF6B1A"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConexxus);
export default __webpack_public_path__ + "static/media/conexxus.8551a18ad922188a2cd1c1c09c87d601.svg";
export { ForwardRef as ReactComponent };